import { fromJS } from 'immutable'

import {
  PPS_IMPORT_ACTUAL_REQUEST,
  PPS_IMPORT_ACTUAL_SUCCESS,
  PPS_IMPORT_ACTUAL_FAILURE,
  PPS_IMPORT_ACTUAL_CLEAR,
} from '../../constants'

const initialState = fromJS({
  is_fetching: false,
  transaction: [],
  status: {},
})

function ppsImportActualReducer(state = initialState, action = {}) {
  switch (action.type) {
    case PPS_IMPORT_ACTUAL_REQUEST:
      return state.set('is_fetching', true)
    case PPS_IMPORT_ACTUAL_SUCCESS: {
      const { status, importTransaction } = action.payload
      return state
        .set('is_fetching', false)
        .set('transaction', fromJS(importTransaction.transaction))
        .set('status', fromJS(status))
    }
    case PPS_IMPORT_ACTUAL_FAILURE:
      return state
    case PPS_IMPORT_ACTUAL_CLEAR:
      return initialState
    default:
      return state
  }
}

export default ppsImportActualReducer



// WEBPACK FOOTER //
// ./src/reducers/project-profit-sheet/pps-import-actual-reducer.js